export function AiResourceSkeleton() {
  return (
    <div className="flex flex-col bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
      {/* Top Section */}
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-lg bg-gray-200" />

        <div className="h-5 w-20 bg-gray-200 rounded-full" />
      </div>

      {/* Title */}
      <div className="space-y-2 mb-3 flex-1">
        <div className="h-4 bg-gray-200 rounded w-full" />
        <div className="h-4 bg-gray-200 rounded w-4/5" />
      </div>

      {/* Category */}
      <div className="h-3 bg-gray-200 rounded w-24 mb-4" />

      {/* Button */}
      <div className="h-3 bg-gray-200 rounded w-28 mt-auto" />
    </div>
  );
};

